export default "__VITE_PUBLIC_ASSET__1bdf7604__"